import * as React from "react";
import {
  SpecialBettingsColorEnum,
  SpecialBettingsParityEnum,
} from "../../enums";

import ColorBetting from "./ColorBetting";
import ParityBetting from "./ParityBetting";

interface Props {
  value: string;
}

const SpecialBettings: React.FC<Props> = ({ value }) => (
  <>
    {(value === SpecialBettingsColorEnum.RED ||
      value === SpecialBettingsColorEnum.BLACK) && (
      <ColorBetting color={value} />
    )}
    {(value === SpecialBettingsParityEnum.EVEN ||
      value === SpecialBettingsParityEnum.ODD) && (
      <ParityBetting parity={value} />
    )}
  </>
);

export default SpecialBettings;
